import React, { useState } from "react";
import playIcon from "../assets/play_btn_new.png";
import { API_BASE } from "../constants/config";
import MediaModal from "./MediaModal";


const MediaCard = ({
  settings,
  gallery,
  folder,
  submitMessage,
  handleDownload,
  handleShare,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <>
      <div className="row">
        {gallery.map((item) => (
          <div key={item.id} className="col-12 col-sm-5 col-md-3 col-lg-2 mb-3">
            <div className="media-card">
              {item.file_type === "image" ? (
                <img
                  className="card-media"
                  src={`${API_BASE}/api/fs-load-image?token=${encodeURIComponent(
                    folder,
                  )}&image=${encodeURIComponent(item.file)}`}
                  alt=""
                  loading="lazy"
                  onClick={() => setSelectedItem(item)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <div
                  className="video-wrapper"
                  onClick={() => setSelectedItem(item)}
                  style={{ cursor: "pointer" }}
                >
                  <img src={playIcon} alt="Play" className="play-icon" />
                  <video
                    className="card-media"
                    src={`${API_BASE}/api/fs-load-image?token=${encodeURIComponent(
                      folder,
                    )}&image=${encodeURIComponent(item.file)}#t=0.002`}
                    muted
                    preload="metadata"
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* SINGLE MODAL */}
      <MediaModal
        open={!!selectedItem}
        item={selectedItem}
        folder={folder}
        API_BASE={API_BASE}
        settings={settings}
        submitMessage={submitMessage}
        handleDownload={handleDownload}
        handleShare={handleShare}
        onClose={() => setSelectedItem(null)}
      />
    </>
  );
};

export default MediaCard;
